module.exports = __webpack_public_path__ + "img/IMG_8919.3d308d00.jpg";